import { LogBox } from 'react-native';

if (__DEV__) {
  LogBox.ignoreLogs([
    'Error fetching offerings - The operation couldn’t be completed.',
    "There's a problem with your configuration. None of the products registered in the RevenueCat dashboard could be fetched",
  ]);
}
